import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-add-product-display-zone',
  templateUrl: './add-product-display-zone.component.html',
  styleUrls: ['./add-product-display-zone.component.css']
})
export class AddProductDisplayZoneComponent implements OnInit {

  
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }
  cProductList: any= []
  zoneName:any = ""
  noOfProductsPerLine:any = ""
  cid:any;
  done:any = [];

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    this.getAllProducts()
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }


  getAllProducts(){
    this.generic_service.getAllProducts().subscribe(
      (response:any)=>{
        console.log(response)
        this.cProductList = [];
        for(let i=0; i<response.response.length;i++){
          let body = {
            "slNo": 0,
            "productId": response.response[i].productMasterId,
            "code": response.response[i].code,
            "name": String(response.response[i].name),
            "group": String(response.response[i].group),
            "description": String(response.response[i].description),
            "imageUrl": String(response.response[i].imageUrl),
            "sku": ""
          }
          this.cProductList.push(body)
        }      
      }
    )
  }

  // getAllCProduct(){
  //   this.generic_service.getAllcProductMaster().subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.cProductList = [];
  //       for(let i=0; i<response.response.length;i++){
  //         let body = {
  //           "slNo": 0,
  //           "productId": response.response[i].cproductId,
  //           "code": response.response[i].code,
  //           "name": String(response.response[i].name),
  //           "group": String(response.response[i].group),
  //           "description": String(response.response[i].description),
  //         }
  //         this.cProductList.push(body)
  //       }
  //     }
  //   )
  // }

  add(){

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "id": "",
      "displayZoneId": 0,
      "seqNo": 0,
      "slNo": 0,
      "zoneName": this.zoneName,
      "productInfoObjList": this.done,
      "cid": Number(this.cid),
      "noOfProductsPerLine": Number(this.noOfProductsPerLine)
    }
    console.log(body)
    this.generic_service.addProductDisplayZone(body).subscribe(
      (response:any)=>{
        console.log(response)
        this.getAllProducts()
        this.done = [];
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  } 

}
